(function () {

  'use strict';

  // **********************************
  //  Data that this directive needs
  // ----------------------------------
  // A printer is required
  // A network is required

  function pxSitePrinterNetwork(
    $http, TenantListService, SnmpConfigurationService, NetworkListPaging, PrinterModel, toastr, $filter, $rootScope
  ) {
    return {
      restrict: 'EA',
      scope: {
        me: '=me',
        isThisSiteMine: '=isThisSiteMine',
        printerInject: '=context',
        network: '=additionalContent',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/sites/sitePrinterNetwork/sitePrinterNetwork.template.html',
      link: function (scope) {

        scope.me = $rootScope.currentUser;
        scope.printer = new PrinterModel(scope.printerInject);
        scope.printerCopy = angular.copy(scope.printer);
        scope.networkId = null;
        scope.snmpConfiguration = null;
        scope.defaultSnmpConfiguration = null;

        (function () {
          getNetworkId();
          getSnmpConfiguration();
          getDefaultSnmpConfiguration();
        })();

        function getNetworkId() {
          scope.networkId = scope.network._links.self.href.slice(-36);
        }

        function getSnmpConfiguration() {
          const url = scope.printer.info._links['px:snmpConfiguration'].href;
          return SnmpConfigurationService.getSnmpConfigurationByUrl(url).then(function (snmpConfiguration) {
            scope.snmpConfiguration = snmpConfiguration;
          }).catch(function(error){});
        }

        function getDefaultSnmpConfiguration() {
          SnmpConfigurationService.getDefaultSnmpConfiguration().then(function (defaultSnmpConfiguration) {
            scope.defaultSnmpConfiguration = defaultSnmpConfiguration;
          }).catch(function(error){});
        }

        function isSnmpConfigurationValidForNetwork() {
          const snmp = scope.snmpConfiguration;
          return !snmp.info.networkIds || !snmp.info.networkIds.length || snmp.info.networkIds.includes(scope.networkId);
        }

        scope.savePrinter = function () {
          const patchObjectArray = [];

          if (scope.snmpConfiguration.info._links.self.href !== scope.printer.info._links['px:snmpConfiguration'].href) {
            const patchObject = {
              op: 'add',
              path: '/snmpConfiguration',
              value: scope.snmpConfiguration.info._links.self.href
            };
            patchObjectArray.push(patchObject);
          }

          if (scope.printerCopy.info.ipAddress !== scope.printer.info.ipAddress) {
            const patchObject = {
              op: 'replace',
              path: '/ipAddress',
              value: scope.printerCopy.info.ipAddress
            };
            patchObjectArray.push(patchObject);
          }

          if (scope.network._links.self.href !== scope.printer.info._links['px:network'].href) {
            const patchObject = {
              op: 'replace',
              path: '/networkId',
              value: scope.network._links.self.href
            };
            patchObjectArray.push(patchObject);
          }

          if (patchObjectArray.length) {
            $http.patch(scope.printer.info._links.self.href, patchObjectArray).then(function (response) {
              toastr.success($filter('translate')('ChangesSaved'));
            }).catch(function(error){
              toastr.error($filter('translate')('ERROR'));
            });
          }

          scope.callback();
        };

        scope.showNetworkList = function () {
          const networkPaginationObject = new NetworkListPaging();
          scope.networkPaginationObject = networkPaginationObject;
          scope.networkListIsVisible = true;
        };

        scope.selectNetwork = function (network) {
          scope.networkListIsVisible = false;
          if (network) {
            scope.network = network.info;
            getNetworkId();
            if (!isSnmpConfigurationValidForNetwork()) {
              scope.snmpConfiguration = scope.defaultSnmpConfiguration;
            }
          }
        };

        scope.showSnmpConfigurationList = function () {
          scope.snmpConfigurationSelectorIsOpen = true;
        };

        scope.selectSnmpConfig = function (snmpConfiguration) {
          scope.snmpConfigurationSelectorIsOpen = false;
          if (snmpConfiguration) {
            scope.snmpConfiguration = snmpConfiguration;
          }
        };

        // TOOLTIP STUFF
        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          if (showTip) {
            const element = angular.element('.context-content-container')[0];
            position.startX = position.startX - element.offsetLeft;
            position.startY = position.startY - element.offsetTop;
            switch (tooltipScope) {
              case 'snmpTooltip':
                snmpTooltip(position, context);
                break;
              case 'network':
                networkTooltip(position, context);
                break;
            }
          } else {
            clearTooltip();
          }
        };

        function snmpTooltip(position, context) {
          clearTooltip();
          scope.tooltipContent = {
            title: context.info.name,
            type: 'snmpDescription',
            icon: 'icon-connection',
            snmpConfiguration: context
          };
          scope.tooltipObject = {
            position: { left: position.startX - 15, top: position.startY + 20 },
            contextMenu: true
          };
        }

        function networkTooltip(position, network) {
          clearTooltip();
          scope.tooltipContent = {
            title: 'Network',
            type: 'networkDetails',
            network: network,
            tenant: angular.copy(TenantListService.currentTenant)
          };
          scope.tooltipObject = {
            position: { left: position.startX - 15, top: position.startY + 20 },
            contextMenu: true
          };
        }

        function clearTooltip() {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        }

      }
    };
  }

  pxSitePrinterNetwork.$inject = [
    '$http', 'TenantListService', 'SnmpConfigurationService', 'NetworkListPaging', 'PrinterModel', 'toastr', '$filter', '$rootScope'
  ];

  angular
    .module('printix-admin')
    .directive('pxSitePrinterNetwork', pxSitePrinterNetwork);

})();
